module.exports = __webpack_public_path__ + "static/media/newbg.505c2423.jpg";